<template>
  <Layout hide-route-header>
    <Card extra-classes="max-w-lg mx-auto">
      <h2 id="users-title" class="text-lg font-medium text-gray-900">Setup your Humaniz phone number</h2>
      <p class="text-sm text-gray-500">
        Text messages you send to candidates and teammates will come from this number.
      </p>

      <form @submit.prevent="setupPhoneNumber">
        <div class="mt-4">
          <TextInput v-model="areaCode" label="Preferred area code" placeholder="415" type="tel" :maxlength="3" />
        </div>
        <div class="mt-4">
          <TButton :disabled="!validAreaCode" label="Setup phone number" />
        </div>
      </form>
    </Card>
  </Layout>
</template>

<script>
import Layout from '../../components/Layout/index.vue';
import Card from '../../components/Card/index.vue';
import TextInput from '../../components/shared/TextInput.vue';
import { createPhoneNumber } from '../../api/quickstart.ts';
export default {
  name: 'QuickstartPhoneNumber',
  components: {
    Layout,
    Card,
    TextInput,
  },
  data() {
    return {
      areaCode: '',
    };
  },
  computed: {
    validAreaCode() {
      return this.areaCode.match(/^\d{3}$/);
    },
  },
  methods: {
    async setupPhoneNumber() {
      const data = await createPhoneNumber(this.areaCode);

      if (data.status != 'error') {
        await this.$router.push('/');
        this.$store.commit('general/showAlert', {
          alertType: 'success',
          alertTitle: 'Phone number created!',
          alertDescription: `Your new Humaniz phone number ${data.record.phone_number} is ready to use.`,
        });
      } else {
        this.$store.commit('general/showAlert', {
          alertType: 'error',
          alertTitle: 'Error creating phone number',
          alertDescription: data.message,
        });
      }
    },
  },
};
</script>
